<template>
    <master-layout>
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="wi wi-cloud-up"></i> {{ $t('incoming_deals') }}</h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>
        <PmlFilter></PmlFilter>
        <PmlList></PmlList>
    </master-layout>
</template>

<script>
    import PmlFilter from './Filter.vue'
    import PmlList from './List.vue'
    import { trans } from 'utils/helpers/translation'

    export default {
        name: 'Incoming',
        metaInfo () {
            return {
                title: trans('incoming_deals')
            }
        },
        components: { PmlList, PmlFilter }
    }
</script>



// WEBPACK FOOTER //
// src/modules/incoming/components/list/Main.vue